(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-section"] && !Shopify.designMode) return;
  try {
    


  const faqs = document.querySelectorAll('.faq-tab');





  const lists = document.querySelectorAll('.faq-list')

  document.addEventListener("DOMContentLoaded", () => {
  const firstTab = faqs[0];
  const firstListId = firstTab.dataset.target;
  const firstList = document.getElementById(firstListId);

  firstTab.classList.add("faq-tab-active");
  firstList.style.display = "block";

  // Ocultar las demás
  lists.forEach(list => {
    if(list !== firstList) list.style.display = "none";
  });
  });

  faqs.forEach(faq => {
    faq.addEventListener("click", () => {

      faqs.forEach(t => t.classList.remove("faq-tab-active")
      );

      faq.classList.add('faq-tab-active')
      

      const targetId = faq.dataset.target;
      

      const targetList = document.getElementById(targetId)

      lists.forEach (list => {
        list.style.display = "none";
      })

      targetList.style.display = "block"

    })
  })




  //Aplica el estilo para girar las flechas
  const questions = document.querySelectorAll(".faq-list-question");

  questions.forEach(question => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      const arrow = question.querySelector(".arrow_down");

      answer.classList.toggle("open");
      
 
      arrow.classList.toggle("arrow_up")
    });
  });


  } catch(e) { console.error(e); }
})();
})();
